import ControlsOutline from './ControlsOutline'

export default ControlsOutline
// eslint-disable-next-line import/export
export * from './ControlsOutline'
